import { PUBLIC_ENV_KEY } from '@/constants/env'

const isBrowser = () => typeof window !== 'undefined' && Boolean(window[PUBLIC_ENV_KEY])

// Server: reads process.env.
// Client: reads window[PUBLIC_ENV_KEY] (injected by PublicEnvScript at runtime).
export const env = (key: string): string | undefined => {
  if (isBrowser()) {
    if (!key.startsWith('NEXT_PUBLIC_')) {
      throw new Error(
        `Environment variable '${key}' is not public and cannot be accessed in the browser.`,
      )
    }
    return window[PUBLIC_ENV_KEY][key]
  }
  return process.env[key]
}
